// src/store/companyInfoSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IAppConfig } from '../interfaces/configInterface';
interface IAppConfigState {
 appConfig: IAppConfig | null;
}

const initialState: IAppConfigState = {
    appConfig: null,
};

export const configSlice = createSlice({
  name: 'context',
  initialState,
  reducers: {
    // setAppConfig: (state, action:  PayloadAction<{ key: string; value: string }>) => {
    setAppConfig: (state, action: PayloadAction<IAppConfig|null>) => {
      return { ...state, appConfig: action.payload };
    },
  },
});

export const {
  setAppConfig,
 
} = configSlice.actions;
export default configSlice.reducer;
